import ContractListing from './ContractListing';

export default ContractListing;
